export default __webpack_public_path__ + "static/media/Ro.d4f800e7.jpeg";